const search = {
  state: {
    displayFilter: false,
    catalogBlocksView: false,
    cols: {
      catalog_filter: 6,
      catalog_results: 6,
    },
    params: {
      page: 1,
      per_page: 10,
      sorting: "date",
      context: "list",
      distance: 10,
    },
    //these keys will help to rerender components
    keys: {
      price: 0,
      radius: 5,
    },
  },
  mutations: {
    setDisplayFilter(state, v) {
      state.displayFilter = v;
    },
    setCatalogBlocksView(state, v) {
      state.catalogBlocksView = v;
    },
    setSearchCol(state, v) {
      state.cols[v.name] = v.value;
    },
    setParameter(state, v) {
      state.params[v.name] = v.value;
    },
    setKey(state, v) {
      state.keys[v.name] = v.value;
    },
  },
  actions: {},
  getters: {
    getDisplayFilter(state) {
      return state.displayFilter;
    },
    getCatalogBlocksView(state) {
      return state.catalogBlocksView;
    },
    getSearchCol: (state) => (name) => {
      return state.cols[name];
    },
    getParameters(state) {
      return state.params;
    },
    getKey: (state) => (name) => {
      return state.keys[name];
    },
  },
};

export default search;
